import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { paths } from '@/shared/lib/paths';
import { useSession } from '../hooks/use-session';

/**
 * Guarda de navegação do layout autenticado. A autorização efetiva acontece sempre na API;
 * aqui só se evita renderizar telas privadas sem sessão.
 */
export function RequireAuth(): ReactNode {
  const status = useSession((state) => state.status);
  const location = useLocation();
  if (status === 'authenticated') return <Outlet />;
  if (status === 'forbidden') return <Navigate replace to={paths.forbidden()} />;
  return <Navigate replace to={paths.login(`${location.pathname}${location.search}`)} />;
}
